export default __webpack_public_path__ + "static/media/speech-to-text.118649ef.png";